import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

const Swagger = () => <SwaggerUI url="https://raw.githubusercontent.com/kev-inc/dealsbro/main/dealsbro-api/swagger.yaml" />

export default Swagger
